import { DpdBucketAccumulative } from "../../../../graphql/generated";

export const DpdBucketAccumulativeOptions = {
  [DpdBucketAccumulative.SevenPlus]: "DPD 7+",
  [DpdBucketAccumulative.FifteenPlus]: "DPD 15+",
  [DpdBucketAccumulative.ThirtyPlus]: "DPD 30+",
  [DpdBucketAccumulative.SixtyPlus]: "DPD 60+",
  [DpdBucketAccumulative.NinetyPlus]: "DPD 90+",
};
